module.exports = __webpack_public_path__ + "static/media/emojis2_06.dee14b5a.svg";